import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=b216bca6"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports